import React from "react";

export function YoutubeOutlined({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.4023 9C17.8008 9 11.6016 9.5 8.30078 10.1992C6.10156 10.6992 4.19922 12.1992 3.80078 14.5C3.40234 16.8984 3 20.5 3 25C3 29.5 3.39844 33 3.89844 35.5C4.30078 37.6992 6.19922 39.3008 8.39844 39.8008C11.9023 40.5 17.8984 41 24.5 41C31.1016 41 37.0977 40.5 40.5977 39.8008C42.8008 39.3008 44.6992 37.8008 45.0977 35.5C45.5 33 46 29.4023 46.0977 24.9023C46.0977 20.4023 45.5977 16.8008 45.0977 14.3008C44.6992 12.1016 42.8008 10.5 40.5977 10C37.0977 9.5 31 9 24.4023 9ZM24.4023 11C31.6016 11 37.3984 11.5977 40.1992 12.0977C41.6992 12.5 42.8984 13.5 43.0977 14.8008C43.6992 18 44.0977 21.4023 44.0977 24.9023C44 29.1992 43.5 32.6992 43.0977 35.1992C42.8008 37.0977 40.8008 37.6992 40.1992 37.9023C36.5977 38.6016 30.5977 39.0977 24.5977 39.0977C18.5977 39.0977 12.5 38.6992 9 37.9023C7.5 37.5 6.30078 36.5 6.10156 35.1992C5.30078 32.3984 5 28.6992 5 25C5 20.3984 5.40234 17 5.80078 14.9023C6.10156 13 8.19922 12.3984 8.69922 12.1992C12 11.5 18.1016 11 24.4023 11ZM19 17V33L33 25L19 17ZM21 20.4023L29 25L21 29.5977V20.4023Z"
        fill="currentColor"
      />
    </svg>
  );
}
